import { DeleteOutlined } from '@ant-design/icons';
import cn from 'classnames';
import * as React from 'react';

import {
  ActionKind,
  ActionParamsButton,
  BaseClickable,
} from 'components/ui/BaseClickable';
import { NewFormulaModel } from 'stores/models';

import s from './ControllersBlock.module.scss';

type Props = {
  formulaModel: NewFormulaModel;
  className?: string;
};

const ControllersBlock: React.FC<Props> = ({
  formulaModel,
  className,
}: Props) => {
  const resetAction: ActionParamsButton<any> = React.useMemo(
    () => ({
      actionKind: ActionKind.button,
      complexOnClick: {
        onClick: (e: React.MouseEvent) => {
          formulaModel.reset();
          e.stopPropagation();
        },
      },
    }),
    [formulaModel]
  );

  return (
    <div className={cn(className)}>
      <BaseClickable
        action={resetAction}
        className={s.iconButton}
        withHover
        withCursorPointer
      >
        <DeleteOutlined />
      </BaseClickable>
    </div>
  );
};

export default ControllersBlock;
